const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Link = require("../core/view/Link");
const {getBaseInstance} = require("../core/util/HOCUtil");

const styles = require("./styles/MinimalTabView.css");

module.exports = createReactClass({
	displayName: "MinimalTabView",

	propTypes: {
		title: PT.node.isRequired,
		tabTitles: PT.arrayOf(PT.string).isRequired,
		tabs: PT.arrayOf(PT.object).isRequired,
		tabLinks: PT.arrayOf(PT.string).isRequired,
		underTabLink: PT.string,
		underTabLinkClass: PT.string,
		underTabLinkText: PT.string,
		selectedTab: PT.number,
		rightEl: PT.node,
		leftEl: PT.node,
		disabled: PT.bool,
	},

	getInitialState: function() {
		this.tabButtons = [];
		return {
			selectedTabIndex: this.props.selectedTab || 0,
			tabOffsets: _.fill(Array(this.props.tabs.length), 0),
		};
	},

	UNSAFE_componentWillReceiveProps: function(newProps) {
		if (newProps.selectedTab !== this.state.selectedTabIndex) {
			this.setState({selectedTabIndex: newProps.selectedTab});
		}
	},

	selectTab: function(tabIndex) {
		this.setState({selectedTabIndex: tabIndex});
	},

	renderTabButton: function(tabTitle, tabIndex, numTabs) {
		const isSelected = tabIndex === this.state.selectedTabIndex;
		let tabClass = isSelected ? styles.selectedTab : styles.cyanTab;
		if (tabIndex === 0) {
			tabClass += " " + styles.firstTab;
		} else if (tabIndex === numTabs - 1) {
			tabClass += " " + styles.lastTab;
		}

		const backgroundStyle = {
			backgroundPosition: -1 * this.state.tabOffsets[tabIndex] + "px 0",
		};

		const capitalizedTitle = tabTitle.toUpperCase();
		return (
			<Link
				key={tabIndex}
				className={tabClass}
				to={this.props.tabLinks[tabIndex]}
				style={backgroundStyle}
				ref={t =>
					(this.tabButtons[tabIndex] = t && getBaseInstance(t).getRef())
				}
			>
				<div className={styles.tabText}>{capitalizedTitle}</div>
			</Link>
		);
	},

	render: function() {
		const numTabs = this.props.tabTitles.length;
		const tabButtons = this.props.tabTitles.map((t, i) =>
			this.renderTabButton(t, i, numTabs)
		);

		let underTabLink = null;
		if (this.props.underTabLink) {
			const underClass =
				styles.underTabLink + " " + (this.props.underTabLinkClass || "");
			underTabLink = (
				<Link
					className={underClass}
					to={this.props.underTabLink}
					isNewTab={true}
				>
					{this.props.underTabLinkText}
				</Link>
			);
		}

		let mainClass = styles.mainContainer;
		if (this.props.disabled === true) {
			mainClass += " " + styles.disabled;
		}

		return (
			<div className={mainClass}>
				<div className={styles.main}>
					<div className={styles.mainTitle}>
						<div className={styles.leftEl}>{this.props.leftEl}</div>
						{this.props.title}
						<div className={styles.rightEl}>{this.props.rightEl}</div>
					</div>
					<div className={styles.tabsContainer}>
						{tabButtons}
						<div className={styles.tabsContainerUnderline} />
						{underTabLink}
					</div>
					<div
						className={styles.tabContainerBody}
						ref={t => (this.tabBody = t)}
					>
						{this.props.tabs[this.state.selectedTabIndex]}
					</div>
				</div>
			</div>
		);
	},
});
